import { Directive, HostListener, Input } from '@angular/core';
import { result } from 'lodash';

export interface IPreventWindowUnloadingOptions {
  onBeforeUnload?: () => boolean;
  onUnload?: () => void;
}

@Directive({
  selector: '[i2gPreventWindowUnloading]',
})
export class PreventWindowUnloadingDirective {
  @Input('i2gPreventWindowUnloading')
  preventWindowUnloading: IPreventWindowUnloadingOptions;

  constructor() {}

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(evt: any): string {
    const unsavedChangesText = 'Unsaved changes';

    if (this.preventWindowUnloading) {
      if (result(this.preventWindowUnloading, 'onBeforeUnload')) {
        evt.returnValue = unsavedChangesText;

        return unsavedChangesText;
      }
    } else {
      evt.returnValue = unsavedChangesText;

      return unsavedChangesText;
    }
  }

  @HostListener('window:unload')
  onUnload() {
    if (this.preventWindowUnloading) {
      result(this.preventWindowUnloading, 'onUnload');
    }
  }
}
